module.exports = __webpack_public_path__ + "img/2_6.6fa92489.png";